import { useState } from "react";
import { runExperianReport } from "../context/functions/AdminFunction";
import { Form, InputGroup } from "react-bootstrap";
import { haveValue } from "../utils/common";

const ExperianReport = (props) => {

  const [isLoading, setIsLoading] = useState(false);
  const [rawResponse, setRawResponse] = useState(null);
  const [formattedResponse, setFormattedResponse] = useState(null);
  const [error, setError] = useState(null);

  const defaultFormState = {
  tenantId: "",
  documentType: "01",
  documentNo: "",
  dob: "",
  postalCode: "",
};

  const [formData, setFormData] = useState(defaultFormState);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((data) => ({ ...data, [name]: value }));
  };

  const isValidForm = haveValue(formData?.documentNo) && haveValue(formData?.dob) && haveValue(formData?.postalCode) && haveValue(formData?.tenantId);

  const handleSubmit = async () => {

    if (!isValidForm) {
      setError("Fill all fields first");
      return false;
    }

    setIsLoading(true);
    setError(null);

    try {

      const response = await runExperianReport(formData);

      if (response?.success_res) {

        const report =
          response.success_res?.["s:Envelope"]?.["s:Body"]?.["GenerarInformeResponse"]?.["GenerarInformeResult"]?.["InformeDelphi4A3"];

        const errorCode = report?.Error?.Codigo;
        setRawResponse(JSON.stringify(response.success_res, null, 2));

        if (errorCode === "0000") {
          setFormattedResponse(report);
        } else {
          setError(report?.Error?.Descripcion || "Unknown error");
          setFormattedResponse(null);
        }
      } else {
        setRawResponse(null);
        setFormattedResponse(null);
        setError(`Failed to check Experian Report`);
      }


    } catch (err) {
      console.error("Error during API call:", err);
      setError(`Failed to check Experian Report: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const preStyle = {
    backgroundColor: "#212529",
    color: "#28a745",
    padding: "1rem",
    borderRadius: "4px",
    overflowX: "auto",
    fontSize: "0.875rem",
    whiteSpace: "pre-wrap"
  };

  const responseData = rawResponse ? JSON.parse(rawResponse) : {};

  return (
    <div className="container py-4">
      <h2 className="text-center mb-4">Experian Report</h2>

      <div className="card mb-4 create-admin-div w-100">
        <div className="card-body w-100">
          <div className="row">
            <label htmlFor="" className="col-12 col-md-6 my-2">
              Document Type
              <InputGroup className="input_table_header">
                <Form.Select
                  name="documentType"
                  value={formData.documentType}
                  onChange={handleInputChange}
                  aria-label="Default select example" required>
                  <option>Select Document Type</option>
                  <option value="01">DNI / NIF</option>
                  <option value="02">NIE</option>
                </Form.Select>
              </InputGroup>{" "}
            </label>
            <label htmlFor="" className="col-12 col-md-6 my-2">
              Document No.
              <InputGroup className="input_table_header">
                <Form.Control
                  placeholder={(formData?.documentType ?? "").toString() === "01" ? "Enter DNI / NIF" : "Enter NIE"}
                  aria-label={(formData?.documentType ?? "").toString() === "01" ? "Enter DNI / NIF" : "Enter NIE"}
                  name="documentNo"
                  aria-describedby="basic-addon1"
                  type="text"
                  value={formData.documentNo}
                  onChange={handleInputChange}
                />
              </InputGroup>{" "}
            </label>
            <label htmlFor="" className="col-12 col-md-6 my-2">
              Postal code
              <InputGroup className="input_table_header">
                <Form.Control
                  placeholder="Enter Postal code"
                  aria-label="Enter Postal code"
                  name="postalCode"
                  aria-describedby="basic-addon1"
                  type="text"
                  value={formData.postalCode}
                  onChange={handleInputChange}
                />
              </InputGroup>{" "}
            </label>
            <label htmlFor="" className="col-12 col-md-6 my-2">
              Date of Birth
              <InputGroup className="input_table_header">
                <Form.Control
                  placeholder="Date of Birth (Format:- DD/MM/YYYY) Example (31/05/1998)"
                  aria-label="Date of Birth (Format:- DD/MM/YYYY) Example (31/05/1998)"
                  name="dob"
                  aria-describedby="basic-addon1"
                  type="text"
                  value={formData.dob}
                  onChange={handleInputChange}
                />
              </InputGroup>{" "}
            </label>
            <label htmlFor="" className="col-12 col-md-6 my-2">
              Tenant ID
              <InputGroup className="input_table_header">
                <Form.Control
                  placeholder="Enter Tenant ID"
                  aria-label="Enter Tenant ID"
                  name="tenantId"
                  type="text"
                  value={formData.tenantId}
                  onChange={handleInputChange}
                />
              </InputGroup>
            </label>
          </div>
          <div className="row">
            <div className="col-12">
              <button
                className={`btn ${isLoading || !isValidForm ? 'disabled' : ''} w-100`}
                disabled={isLoading || !isValidForm}
                onClick={handleSubmit}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Processing...
                  </>
                ) : (
                  "Check Report"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Error Message */}
      {error && (
        <div className="alert alert-danger mb-4" role="alert">
          {error}
        </div>
      )}

      {/* Results Display */}
      {(rawResponse || formattedResponse) && (
        <>
          <h3 className="mb-3">Report</h3>

          <div className="row">

            {/* Formatted Response */}
            <div className="col-md-12 mb-4">
              <div className="card">
                <div className="card-header">Formatted Response</div>
                <div className="card-body">
                  <h5 className="card-title">Delphi</h5>
                  <p className="card-text mb-3">{formattedResponse?.InformacionDelphi?.Nota ?? "-"}</p>

                  <h5 className="card-title">Probabilidad de Impago</h5>
                  <p className="card-text mb-3">{formattedResponse?.InformacionDelphi?.ProbabilidadIncumplimientoPorScore ?? "-"}</p>

                  <hr />

                  <h5 className="card-title">Importe Impagado</h5>
                  <p className="card-text mb-3">{formattedResponse?.ResumenCais?.ImporteImpagado ?? "-"}</p>

                  <h5 className="card-title">N° de Operaciones Impagadas</h5>
                  <p className="card-text mb-3">{formattedResponse?.ResumenCais?.NumeroOperacionesImpagadas ?? "-"}</p>

                  <h5 className="card-title">N° de Cuotas Impagadas</h5>
                  <p className="card-text mb-3">{formattedResponse?.ResumenCais?.NumeroCuotasImpagadas ?? "-"}</p>

                  <h5 className="card-title">Máximo Importe Impagado</h5>
                  <p className="card-text mb-3">{formattedResponse?.ResumenCais?.MaximoImporteImpagado ?? "-"}</p>
                </div>
              </div>
            </div>

            <div className="col-md-12 mb-4">
              <div className="card">
                <div className="card-header">Detalle Badexcug</div>
                <div className="card-body table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Tipo de Acreedor</th>
                        <th>Producto</th>
                        <th>Importe de las operaciones</th>
                        <th>Situación</th>
                        <th>Nº de impagados</th>
                        <th>Importe impagados</th>
                        <th>Fecha primer impago</th>
                        <th>Fecha último impago</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        responseData.badexcug && responseData.badexcug.length > 0 ? <>
                          {
                            responseData.badexcug.map((badexcug) => {
                              return <>
                                <tr>
                                  <td>{badexcug?.tipoDeAcreedor ?? ""}</td>
                                  <td>{badexcug?.producto ?? ""}</td>
                                  <td>{badexcug?.importeDeLasOperaciones ?? ""}</td>
                                  <td>{badexcug?.situacion ?? ""}</td>
                                  <td>{badexcug?.numeroDeImpagados ?? ""}</td>
                                  <td>{badexcug?.importeImpagados ?? ""}</td>
                                  <td>{badexcug?.fechaPrimerImpago ?? ""}</td>
                                  <td>{badexcug?.fechaUltimoImpago ?? ""}</td>
                                </tr>
                              </>
                            })
                          }
                        </> : null
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Raw Response */}
            <div className="col-md-12 mb-4">
              <div className="card">
                <div className="card-header">Raw Response</div>
                <div className="card-body">
                  <pre style={preStyle}>
                    {rawResponse}
                  </pre>
                </div>
              </div>
            </div>

          </div>
        </>
      )}
    </div>
  );
};

export default ExperianReport;